import { CSClient, type CSTypes } from '@tf/api';

export const getProcessingScriptsQuery = async (revision: string): Promise<CSTypes.GetScriptsResponse> => {
	const res = await CSClient.getInstance().getScripts({ revision: revision });
	return res.json();
};
